(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["offer-countdown-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('offer-countdown-banner')) return;

    var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

    // How far ahead of UTC the zone is at instant t, in ms (BST vs GMT). Browsers without time-zone
    // support fall back to the shop's offset when the page was rendered.
    var formatters = {};
    function zoneOffset(t, tz, fallback) {
      try {
        var f = formatters[tz] || (formatters[tz] = new Intl.DateTimeFormat('en-GB', {
          timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
          hour: '2-digit', minute: '2-digit', second: '2-digit'
        }));
        var p = {};
        f.formatToParts(new Date(t)).forEach(function (x) { p[x.type] = +x.value; });
        return Date.UTC(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second) - Math.floor(t / 1000) * 1000;
      } catch (e) {
        return fallback;
      }
    }

    // "+0100" → 3600000
    function parseOffset(s) {
      var m = /^([+-])(\d{2})(\d{2})$/.exec(s || '');
      return m ? (m[1] === '-' ? -1 : 1) * (+m[2] * 60 + +m[3]) * 60000 : 0;
    }

    var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    // The UK wall-clock time of an instant, as a Date to read with getUTC*().
    function wall(t, tz, fallback) { return new Date(t + zoneOffset(t, tz, fallback)); }

    // The UK calendar day an instant falls on, as a UTC-midnight timestamp (so days can be compared and named).
    function ukDay(t, tz, fallback) {
      var d = wall(t, tz, fallback);
      return Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    }

    // "Ends tonight" / "Ends today at 3pm" / "Ends tomorrow" / "Ends Thursday at 9am" / "Ends Sun 5 Oct"
    // (the last matches the Liquid label rendered before this runs). 23:59 and midnight both mean
    // "the end of that day"; midnight belongs to the day before.
    function endsLabel(prefix, end, now, tz, fallback) {
      var w = wall(end, tz, fallback);
      var h = w.getUTCHours(), mi = w.getUTCMinutes();
      var midnight = h === 0 && mi === 0;
      var at = (h === 23 && mi === 59) || midnight ? '' :
        ' at ' + (h === 12 && mi === 0 ? 'midday' : (h % 12 || 12) + (mi ? ':' + pad(mi) : '') + (h < 12 ? 'am' : 'pm'));
      var endDay = ukDay(midnight ? end - 60000 : end, tz, fallback);
      var days = Math.round((endDay - ukDay(now, tz, fallback)) / 86400000);
      var day = new Date(endDay);
      var when;
      if (days === 0) when = at ? 'today' + at : 'tonight';
      else if (days === 1) when = 'tomorrow' + at;
      else if (days < 7) when = DAYS[day.getUTCDay()] + at;
      else when = DAYS[day.getUTCDay()].slice(0, 3) + ' ' + day.getUTCDate() + ' ' + MONTHS[day.getUTCMonth()] + at;
      return (prefix + ' ' + when).trim();
    }

    var AFTER_END = {
      hide_timer: 'the title and saving, with no badge, countdown or urgency line',
      show_message: '"This offer has ended" above the title',
      plain_title: 'just the collection title, as a plain heading'
    };

    customElements.define('offer-countdown-banner', class extends HTMLElement {
      connectedCallback() {
        clearTimeout(this._handle);
        if (!this.dataset.end) return;
        // If this ever runs while the page is still parsing (e.g. the script is inlined), an element
        // can be upgraded before its children exist: wait for the rest of the page.
        if (!this.querySelector('[data-ocb-timer]') && document.readyState === 'loading') {
          var self = this;
          document.addEventListener('DOMContentLoaded', function () { if (self.isConnected) self.connectedCallback(); }, { once: true });
          return;
        }
        this._timer = this.querySelector('[data-ocb-timer]');
        if (!this._timer) return;
        this._tz = this.dataset.tz || 'Europe/London';
        this._fallback = parseOffset(this.dataset.fallbackOffset);
        this._end = +this.dataset.end * 1000;
        this._start = this.dataset.start ? +this.dataset.start * 1000 : 0;
        if (!this._end) return;
        this._ends = this.querySelector('[data-ocb-ends]');
        this._prefix = this.dataset.endsPrefix != null ? this.dataset.endsPrefix : 'Ends';
        this._el = {
          days: this.querySelector('[data-ocb-days]'), hours: this.querySelector('[data-ocb-hours]'),
          mins: this.querySelector('[data-ocb-mins]'), secs: this.querySelector('[data-ocb-secs]'),
          dayTile: this.querySelector('[data-unit="days"]')
        };
        this._tick = this._tick.bind(this);
        this._tick();
        if (typeof ResizeObserver === 'function' && !this._resize) {
          var el = this;
          this._resize = new ResizeObserver(function () { el._fitBadge(); });
        }
        if (this._resize) this._resize.observe(this);
      }

      disconnectedCallback() {
        clearTimeout(this._handle);
        if (this._resize) this._resize.disconnect();
      }

      // One-line "Limited time only | Ends …" pill wherever it fits; when the date would wrap, two
      // deliberate lines instead of a half-empty wide box.
      _fitBadge() {
        var badge = this.querySelector('.ocb__badge');
        var text = badge && badge.querySelector('.ocb__badge-text');
        var end = badge && badge.querySelector('.ocb__badge-end');
        if (!text || !end) return;
        badge.classList.remove('is-stacked');
        if (end.getBoundingClientRect().top > text.getBoundingClientRect().top + 2) badge.classList.add('is-stacked');
      }

      _tick() {
        var now = Date.now();
        var left = this._end - now;
        if (left <= 0) return this._finish();
        var waiting = this._start && now < this._start;
        var badge = this.querySelector('.ocb__badge');
        var urgency = this.querySelector('[data-ocb-urgency]');
        if (badge) badge.hidden = !!waiting;
        if (urgency) urgency.hidden = !!waiting;
        if (waiting) {
          this._timer.hidden = true;
          this._handle = setTimeout(this._tick, Math.min(this._start - now + 20, 2147483647));
          return;
        }
        var s = Math.floor(left / 1000);
        var d = Math.floor(s / 86400);
        this._el.days.textContent = pad(d);
        this._el.hours.textContent = pad(Math.floor(s / 3600) % 24);
        this._el.mins.textContent = pad(Math.floor(s / 60) % 60);
        this._el.secs.textContent = pad(s % 60);
        this._el.dayTile.hidden = d === 0;
        this.classList.toggle('is-final-day', left < 86400000);
        if (this._ends) {
          var label = endsLabel(this._prefix, this._end, now, this._tz, this._fallback);
          if (label !== this._ends.textContent) {
            this._ends.textContent = label;
            this._fitBadge();
          }
        }
        this._timer.removeAttribute('data-ocb-pending');
        this._timer.hidden = false;
        this._handle = setTimeout(this._tick, 1000 - (now % 1000) + 20);
      }

      // Nothing that implies the offer is still running may stay on the page once it has ended.
      _finish() {
        clearTimeout(this._handle);
        var mode = AFTER_END[this.dataset.ended] ? this.dataset.ended : 'hide_timer';
        var badge = this.querySelector('.ocb__badge');
        var sub = this.querySelector('[data-ocb-sub]');
        var urgency = this.querySelector('[data-ocb-urgency]');
        this.classList.add('is-ended');
        this._timer.hidden = true;
        if (urgency) urgency.hidden = true;
        // "This offer has ended" next to "Up to 50% off" would contradict itself, so the saving goes too
        if (sub && mode !== 'hide_timer') sub.hidden = true;
        if (badge) {
          if (mode === 'show_message') badge.textContent = 'This offer has ended';
          else badge.hidden = true;
        }
        if (mode === 'plain_title') this.classList.add('is-plain');
        if (this.hasAttribute('data-design-mode')) {
          var end = new Date(ukDay(this._end, this._tz, this._fallback));
          var note = this.querySelector('[data-ocb-ended-note]') || this.appendChild(document.createElement('p'));
          note.className = 'ocb__editor-note';
          note.setAttribute('data-ocb-ended-note', '');
          note.textContent = 'This offer ended on ' + DAYS[end.getUTCDay()] + ' ' + end.getUTCDate() + ' ' + MONTHS[end.getUTCMonth()] + ' ' +
            end.getUTCFullYear() + '. Customers now see ' + AFTER_END[mode] +
            '. Check the year under Offer ends if that is not what you meant. Only you can see this note.';
        }
        this.dispatchEvent(new CustomEvent('offer:ended', { bubbles: true }));
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
